<template>
  <div>
    <v-snackbar v-model="snackbar">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          확인
        </v-btn>
      </template>
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    snackbar: false,
    text: "",
  }),
  created: function() {
    this.$bus.$on("alert", (text) => {
      this.snackbar = true;
      this.text = text;
    });
  },
};
</script>
